<!-- 
Panel showing the levy parameters.
-->
<!-- eslint-disable -->
<template>
  <our-data-container v-if="levyParameters != null" right fluid>

    <v-flex xs3 offset-xs1>
      <h3 class="title">{{ loansHeading }}</h3>
    </v-flex>
    <v-flex xs12>&nbsp;</v-flex>
    <our-data-field :label="`Total ${levyCollectionTypeDescription} ${loansDescription} in ${levyCollectionYear - 1}`" label-width="3">
      {{ levyParameters.loanAmountsPaid | currency }}
    </our-data-field>
    <v-flex xs12>&nbsp;</v-flex>

    <v-flex xs3 offset-xs1>
      <h3 class="title">Students</h3>
    </v-flex>
    <v-flex xs12>&nbsp;</v-flex>
    <our-data-field :label="`${levyCollectionTypeDescription} students in ${levyCollectionYear - 1}`" label-width="3">
      {{ levyParameters.studentCount | number }}
    </our-data-field>
    <v-flex xs12>&nbsp;</v-flex>

    <template>
      <v-flex xs3 offset-xs1>
        <h3 class="title">Equivalent full-time student load</h3>
      </v-flex>
      <v-flex xs12>&nbsp;</v-flex>
      <our-data-field :label="`Passed EFTSL (${year1})`" label-width="3">{{ levyParameters.passedEftsl | numericInput3 }}</our-data-field>
      <our-data-field :label="`Withdrawn EFTSL (${year1})`" label-width="3">{{ levyParameters.withdrawnEftsl | numericInput3 }}</our-data-field>
      <our-data-field :label="`Failed EFTSL (${year1})`" label-width="3">{{ levyParameters.failedEftsl | numericInput3 }}</our-data-field>
      <our-data-field :label="`Ongoing EFTSL (${year1})`" label-width="3">{{ levyParameters.ongoingEftsl | numericInput3 }}</our-data-field>
      <our-data-field :label="`Missing EFTSL (${year1})`" label-width="3">{{ levyParameters.missingEftsl | numericInput3 }}</our-data-field>
      <v-flex xs12>&nbsp;</v-flex>
    </template>

    <v-flex xs3 offset-xs1>
      <h3 class="title">Financial</h3>
    </v-flex>
    <v-flex xs12>&nbsp;</v-flex>
    <our-data-field label="Net profit before tax" label-width="3">{{ levyParameters.netProfitBeforeTax | currency }}</our-data-field>
    <our-data-field label="Total revenue" label-width="3">{{ levyParameters.totalRevenue | currency }}</our-data-field>
    <our-data-field label="Total assets" label-width="3">{{ levyParameters.totalAssets | currency }}</our-data-field>
    <our-data-field label="Total liabilities" label-width="3">{{ levyParameters.totalLiabilities | currency }}</our-data-field>
    <our-data-field label="Total equity" label-width="3">{{ levyParameters.totalEquity | currency }}</our-data-field>
    <our-data-field label="Financial statement supplied" label-width="3">{{ levyParameters.financialStatementSupplied | yesNo }}</our-data-field>
    <v-flex xs12>&nbsp;</v-flex>

    <v-flex xs3 offset-xs1>
      <h3 class="title">Non-compliance history</h3>
    </v-flex>
    <v-flex xs12>&nbsp;</v-flex>
    <our-data-field v-if="showLtpsLatePaymentDays(1)" :label="`${ltpsLevyLabel} (${year1})`" label-width="3" empty="Not applicable">
      {{ levyParameters.ltpsLevyLatePaymentDaysInPreviousYear }}
    </our-data-field>
    <our-data-field v-if="showLtpsLatePaymentDays(2)" :label="`${ltpsLevyLabel} (${year2})`" label-width="3" empty="Not applicable">
      {{ levyParameters.ltpsLevyLatePaymentDaysInPreviousYearMinus1 }}
    </our-data-field>
    <our-data-field v-if="showLtpsLatePaymentDays(3)" :label="`${ltpsLevyLabel} (${year3})`" label-width="3" empty="Not applicable">
      {{ levyParameters.ltpsLevyLatePaymentDaysInPreviousYearMinus2 }}
    </our-data-field>
    <our-data-field v-if="showLtpsLatePaymentDays(4)" :label="`${ltpsLevyLabel} (${year4})`" label-width="3" empty="Not applicable">
      {{ levyParameters.ltpsLevyLatePaymentDaysInPreviousYearMinus3 }}
    </our-data-field>
    <our-data-field v-if="showLtpsLatePaymentDays(5)" :label="`${ltpsLevyLabel} (${year5})`" label-width="3" empty="Not applicable">
      {{ levyParameters.ltpsLevyLatePaymentDaysInPreviousYearMinus4 }}
    </our-data-field>
    <our-data-field v-if="showAnnualChargeLatePaymentDays(1)" :label="`${annualChargeLabel} (${year1})`" label-width="3" empty="Not applicable">
      {{ levyParameters.annualChargeLatePaymentDaysInPreviousYear }}
    </our-data-field>
    <our-data-field v-if="showAnnualChargeLatePaymentDays(2)" :label="`${annualChargeLabel} (${year2})`" label-width="3" empty="Not applicable">
      {{ levyParameters.annualChargeLatePaymentDaysInPreviousYearMinus1 }}
    </our-data-field>
    <our-data-field v-if="showAnnualChargeLatePaymentDays(3)" :label="`${annualChargeLabel} (${year3})`" label-width="3" empty="Not applicable">
      {{ levyParameters.annualChargeLatePaymentDaysInPreviousYearMinus2 }}
    </our-data-field>
    <our-data-field v-if="showAnnualChargeLatePaymentDays(4)" :label="`${annualChargeLabel} (${year4})`" label-width="3" empty="Not applicable">
      {{ levyParameters.annualChargeLatePaymentDaysInPreviousYearMinus3 }}
    </our-data-field>
    <our-data-field v-if="showAnnualChargeLatePaymentDays(5)" :label="`${annualChargeLabel} (${year5})`" label-width="3" empty="Not applicable">
      {{ levyParameters.annualChargeLatePaymentDaysInPreviousYearMinus4 }}
    </our-data-field>
    <our-data-field label="Sanctioned" label-width="3" empty="Not applicable">
      {{ levyParameters.sanctioned | yesNo }}
    </our-data-field>
    <our-data-field v-if="levyCollection.enableShortRegistrationPeriodRiskFactor" label="Short registration renewal period" label-width="3" empty="Not applicable">
      {{ shortRegistrationPeriodDescription }}
    </our-data-field>
    <v-flex xs12>&nbsp;</v-flex>

    <v-flex xs3 offset-xs1>
      <h3 class="title">Special cases</h3>
    </v-flex>
    <v-flex xs12>&nbsp;</v-flex>
    <our-data-field :label="`New ${levyCollectionTypeDescription} provider for ${levyCollectionYear}?`" label-width="3">{{ levyParameters.isNew | yesNo }}</our-data-field>
    <our-data-field :label="`Is liable for last year's administrative fee?`" label-width="3">{{ levyParameters.isLiableForLastYearsAdministrativeFee | yesNo }}</our-data-field>
    <v-flex xs12>&nbsp;</v-flex>

  </our-data-container>
</template>
<!-- eslint-enable -->

<script>
import filterMixins from "@/mixins/filter.mixins";
import lookupMixins from "@/mixins/lookup.mixins";

export default {
  mixins: [filterMixins, lookupMixins],
  props: {
    levyParameters: {
      type: Object,
      required: true
    },
    levyCollection: {
      type: Object,
      default: null
    },
    forProvider: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    levyCollectionYear() {
      return this.levyCollection ? this.levyCollection.year : null;
    },
    levyCollectionType() {
      return this.levyCollection ? this.levyCollection.type : "";
    },
    levyCollectionTypeDescription() {
      return this.levyCollectionType ? this.lookups.levyCollectionTypeDescriptions[this.levyCollectionType] : "";
    },
    vsl() {
      return this.levyCollectionType && this.levyCollectionType.startsWith("Vsl");
    },
    help() {
      return this.levyCollectionType && this.levyCollectionType.startsWith("Help");
    },
    upfront() {
      return this.levyCollectionType && this.levyCollectionType.startsWith("Upfront");
    },
    loansHeading() {
      return this.upfront ? "Payments" : "Loans";
    },
    loansDescription() {
      return this.upfront ? "payments" : "loans";
    },
    ltpsLevyLabel() {
      return this.vsl
        ? "VSL levy days late"
        : this.help
          ? "HELP levy days late"
          : this.upfront
            ? "Up-front levy days late"
            : "UNKNOWN levy days late";
    },
    annualChargeLabel() {
      return this.vsl
        ? "VSL approved course provider charge days late"
        : this.help
          ? "Higher Education provider charge days late"
          : this.upfront
            ? "Up-front provider charge days late"
            : "UNKNOWN provider charge days late";
    },
    year1() {
      return this.levyCollectionYear - 1;
    },
    year2() {
      return this.levyCollectionYear - 2;
    },
    year3() {
      return this.levyCollectionYear - 3;
    },
    year4() {
      return this.levyCollectionYear - 4;
    },
    year5() {
      return this.levyCollectionYear - 5;
    },
    shortRegistrationPeriodDescription() {
      return this.levyParameters.shortRegistrationPeriod
        ? "True"
        : this.levyParameters.shortRegistrationPeriod == null ||
          this.levyParameters.shortRegistrationPeriod == undefined
          ? ""
          : "False";
    }
  },
  methods: {
    showAnnualChargeLatePaymentDays(number) {
      return this.levyCollection.numberOfAnnualChargeLatePaymentYears >= number;
    },
    showLtpsLatePaymentDays(number) {
      return this.levyCollection.numberOfLtpsLatePaymentYears >= number;
    }
  }
};
</script>
